//Types
import {
    CARGAR_SOLI,
    MODIFICAR_SOLI,
    GUARDAR_SOLICITUD,
    CARGANDO_ADD,
    ERROR_ADD,
    SELECCIONAR_FILE,
    ELIMINAR_FILE,
    ERROR,
    LIMPIAR_ERROR
} from "./agregarSoliAjusActions";

const agregarSoliAjusReducer = (state, action) => {
    switch (action.type) {

        case CARGAR_SOLI: {
            return {
                ...state,
                soliAjus: { ...state.soliAjus, ...action.payload },
                modSoliAjus: false,
                cargando: false,
                error: ""
            }
        }
        case MODIFICAR_SOLI: {
            return {
                ...state,
                modSoliAjus: action.payload,
                cargando: false,
                error: ""
            }
        }

        case GUARDAR_SOLICITUD: {
            return {
                ...state,
                soliAjus: {
                    nroCta: "",
                },
                modSoliAjus: false,
                cargando: false,
                error: ""
            }
        }

        case CARGANDO_ADD:
            return {
                ...state,
                cargando: true,
                error: ""
            }

        case ERROR_ADD:
            return {
                ...state,
                cargando: false,
                error: action.payload
            }

        case SELECCIONAR_FILE:
            return {
                ...state,
                files: [...state.files, action.payload]
            }

        case ELIMINAR_FILE:
            return {
                ...state,
                files: state.files.filter((file) => file.name !== action.payload.name),
            }


        case ERROR: {
            return {
                ...state,
                error: action.payload
            }
        }

        case LIMPIAR_ERROR: {
            return {
                ...state,
                error: ""
            }
        }


        default:
            return state;
    }
}

export default agregarSoliAjusReducer;